import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Seo from '@/seo/Seo';

const features = [
  { icon: 'ri-shield-check-line', title: 'Güvenli Taşımacılık', desc: 'Yükleriniz sigortalı ve güvence altında taşınır.' },
  { icon: 'ri-time-line', title: 'Zamanında Teslimat', desc: 'Belirlenen sürelerde teslimat garantisi veriyoruz.' },
  { icon: 'ri-global-line', title: 'Geniş Uluslararası Ağ', desc: '8 ülkeye yurtiçi, yurtdışı ve uluslararası düzenli sefer düzenliyoruz.' },
  { icon: 'ri-customer-service-2-line', title: '7/24 Destek', desc: 'Her an ulaşabileceğiniz müşteri hizmetleri.' },
  { icon: 'ri-truck-line', title: 'Modern Araç Filosu', desc: 'Bakımlı ve donanımlı araçlarla taşımacılık.' },
  { icon: 'ri-file-list-3-line', title: 'Gümrük Uzmanlığı', desc: 'Tüm gümrük işlemlerini sizin adınıza yönetiyoruz.' },
];

export default function AboutPage() {
  return (
    <div className="min-h-screen" style={{ fontFamily: "'Inter', sans-serif" }}>
      <Seo
        title="Hakkımızda | Global79 Lojistik"
        description="Global79 Lojistik'in hikayesini, deneyimini ve uluslararası taşımacılıkta sunduğu güvenilir çözümleri keşfedin. Kilis merkezli ekibimizle yüklerinizi güvenle taşıyoruz."
        path="/hakkimizda"
        keywords="Global79 hakkında, lojistik firması Kilis, güvenilir taşımacılık, uluslararası lojistik deneyimi"
        ogImage="/assets/images/about-warehouse.png"
      />
      <Navbar />

      {/* Page Hero — Single Banner */}
      <section
        className="relative h-72 md:h-96 flex items-center justify-center overflow-hidden bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('/assets/images/hero-slide-1.png')`,
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70" />
        <div className="relative z-10 text-center px-4">
          <span className="text-orange-400 text-sm font-bold uppercase tracking-widest mb-3 block">Biz Kimiz</span>
          <h1 className="text-4xl md:text-6xl font-extrabold text-white" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Hakkımızda
          </h1>
          <p className="text-gray-300 mt-4 text-base max-w-xl mx-auto">
            Kilis merkezli yurtiçi, yurtdışı ve uluslararası güvenilir lojistik çözüm ortağınız
          </p>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="flex flex-col lg:flex-row gap-16 items-center">
            <div className="w-full lg:w-1/2">
              <span className="text-orange-500 text-sm font-bold uppercase tracking-widest mb-4 block">Hikayemiz</span>
              <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight mb-6" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                Sınır Tanımayan<br /><span className="text-orange-500">Lojistik</span><br />Güvenle Taşıyoruz
              </h2>
              <p className="text-gray-500 text-base leading-relaxed mb-5">
                Global79 Lojistik olarak, Kilis merkezli firmamızdan yurtiçi ve yurtdışı güzergahlarda düzenli ve güvenilir taşımacılık hizmeti sunuyoruz. Türkiye, Suriye, Azerbaycan, Irak, İran, Gürcistan, Ermenistan ve Rusya&apos;ya uzanan geniş ağımızla müşterilerimizin yüklerini en hızlı ve güvenli şekilde teslim ediyoruz.
              </p>
              <p className="text-gray-500 text-base leading-relaxed mb-8">
                Deneyimli ekibimiz ve modern araç filomuzla, parsiyel ve komple yük taşımacılığında sektörün en güvenilir ismi olmayı hedefliyoruz. Her yükü kendi yükümüz gibi taşıyoruz.
              </p>
              <div className="flex flex-wrap gap-6">
                {[{ val: '15+', lbl: 'Yıllık Tecrübe' }, { val: '8', lbl: 'Hizmet Ülkesi' }, { val: '500+', lbl: 'Mutlu Müşteri' }].map((s) => (
                  <div key={s.lbl} className="text-center">
                    <div className="text-3xl font-extrabold text-orange-500">{s.val}</div>
                    <div className="text-gray-500 text-sm mt-1">{s.lbl}</div>
                  </div>
                ))}
              </div>
            </div>
            <div className="w-full lg:w-1/2 flex gap-4 h-[420px]">
              <div className="w-[45%] rounded-2xl overflow-hidden">
                <img src="/assets/images/about-warehouse.png" alt="Depo" loading="eager" className="w-full h-full object-cover object-top" />
              </div>
              <div className="w-[55%] flex flex-col gap-4">
                <div className="flex-1 rounded-2xl overflow-hidden">
                  <img src="/assets/images/about-truck.png" alt="Kamyon" loading="eager" className="w-full h-full object-cover object-top" />
                </div>
                <div className="flex-1 rounded-2xl bg-orange-500 flex flex-col items-center justify-center p-6 text-center">
                  <div className="text-4xl font-extrabold text-white mb-1">15+</div>
                  <div className="text-white/90 font-semibold">Yıllık Tecrübe</div>
                  <div className="text-white/70 text-xs mt-1">Uluslararası lojistikte güvenilir çözüm ortağınız</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-20" style={{ background: '#f8f6f3' }}>
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-center mb-14">
            <span className="text-orange-500 text-sm font-bold uppercase tracking-widest mb-3 block">Neden Biz?</span>
            <h2 className="text-4xl font-extrabold text-gray-900" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Farkımız Ne?
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((f) => (
              <div key={f.title} className="bg-white rounded-2xl p-7 hover:-translate-y-1 transition-transform">
                <div className="w-12 h-12 flex items-center justify-center bg-orange-50 rounded-xl mb-4">
                  <i className={`${f.icon} text-orange-500 text-2xl`} />
                </div>
                <h3 className="font-bold text-gray-900 text-lg mb-2">{f.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20" style={{ background: '#f8f6f3' }}>
        <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Bizi Tanımak İster misiniz?
          </h2>
          <p className="text-gray-500 text-base mb-8 max-w-xl mx-auto">
            Lojistik ihtiyaçlarınız için hemen iletişime geçin, size en uygun çözümü sunalım.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:05382323822"
              className="inline-flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white font-bold px-10 py-4 rounded-full transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-fill" />
              Hemen Ara
            </a>
            <a
              href="/iletisim"
              className="inline-flex items-center gap-2 border-2 border-gray-300 hover:border-orange-500 text-gray-700 hover:text-orange-500 font-bold px-10 py-4 rounded-full transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-arrow-right-line" />
              İletişim Sayfası
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
